import React from 'react'
import { Button } from 'sdc-react-basics'

export const CreateButton = ({...params}) => (
  <Button icon="plus" style={{color: '#090'}} {...params} />
)
